<template>
    <div>
      <div class="mainHead">
        <div class="route">
          <span class="crumbs"></span><span class="link" @click="returnBtn">监测点管理</span><span class="arrow">></span><span>保存成功</span>
        </div>
        <div> 
          <el-button type="primary" @click="returnBtn">返回</el-button>
        </div>
      </div>
      <div class="fixedScroll" :style="{height: heightCard + 'px'}">
        <div class="maindetails">
            <div class="save">
                <div class="saveIcon"><img src="../../assets/img/save.png" alt=""><span>保存成功!</span></div>
                <div class="saveBtn">
                    <div @click="roteAdd" v-if="isAuth('basicData:insertMonitorInfo')"><el-button type="primary">新增监测点</el-button></div>
                    <!-- <div @click="roteWarrant" v-if="isAuth('userMonitoring:binUserMonitor')"><el-button type="primary">监测点授权</el-button></div> -->
                    <div @click="roteView"><el-button type="primary">查看监测点信息</el-button></div>
                </div>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: 'saveSuccessfully',
        components: {
          
        },
        data() {
            return {
               heightCard:''
            }
        },
        created() {
            sessionStorage.setItem('complete',true)
        },
        mounted() {
            let that = this;
            function initFont() {
                that.heightCard = $(document.body).height() - $('.el-header').outerHeight(true)- $('.mainHead').outerHeight(true) -20;
                that.heightBg =  that.heightCard -$('.maindetails').outerHeight(true);
            }initFont();
            $(window).resize(initFont);
        },
        methods: {
            returnBtn(){ //返回按钮;
               this.$router.push({path:'/content/BasicData'}); //监测点首页
            },
            roteAdd(){ //新增监测点
               this.$router.push({path:'/content/addMonitor',query:{IStrue:'false'}}); //进入非监测点详情
            },
            // roteWarrant(){//监测点授权
            //     this.$router.push({path:'../permissionManger'}); //进入授权页
            // },
            roteView(){ //查看监测点信息
                this.$router.push({path:'/content/addMonitor',query:{IStrue:'true'}}); //进入监测点详情
            }
        }
    }
</script>

<style scoped lang="scss">
@import "@/assets/css/mixin.scss";
// 内容布局
.el-main{
  width: 78.1%;
  margin:10px 0 7px 1.05%;
  padding: 0;
  .maindetails{
      height: 100%;
      padding-top: 145px;
      margin-right: 1.05%;
      background-color:#fff;
  }
}
.save{
    .saveIcon{
        @include flexible;
        @include alignItems(center);
        @include justify(center);
        font-size: 28px;
        color: #4caf50;
        font-weight: bold;
        &>span{
            margin-left: 10px;
            display: inline-block;
            vertical-align: middle
        }
        img{
            width: 36px;
            height: 36px;
        }
    
    }
    .saveBtn{
        margin-top: 60px;
        @include flexible;
        @include alignItems(center);
        @include justify(center);
        .el-button{
            width: 200px;
            height: 40px;
            padding: 0;
            font-size: 16px !important;
        }
        &>div{
            margin-right: 20px;
            &:last-child{
                margin-right: 0;
            }
        }
    }
}

</style>


// WEBPACK FOOTER //
// src/page/BasicData/saveSuccessfully.vue